import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import "./button.css";
const Button = (props) => {
    return (
        <Link  to={props.href} activeclassname="selected" scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
            <div className="button montserrat fw-bold">
                {props.text}
            </div>
        </Link >
    );      
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/function/button/button.js